import { render, staticRenderFns } from "./AccidentMotor.vue?vue&type=template&id=1f0e3ada"
import script from "./AccidentMotor.vue?vue&type=script&lang=js"
export * from "./AccidentMotor.vue?vue&type=script&lang=js"
import style0 from "./AccidentMotor.vue?vue&type=style&index=0&id=1f0e3ada&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports